import { Box } from 'gestalt';

export default function EmptyBox() {
  return <Box />;
}
